import { Inject, Injectable } from '@angular/core';
import { getDate12AsInt } from '@cawita/core-front';
import { CwtApiService, mapApiDataItem } from '@cawita/core-front/api';
import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { Notification, NotificationCheck } from '../../../../../frontend-shared/src/lib/models';
import { GenericCrudService, getCrudName } from '../../../../../frontend-shared/src/lib/modules/crud';

@Injectable({ providedIn: 'root' })
export class NotificationAPI {
    constructor(
        @Inject(getCrudName(Notification)) private notificationCrud: GenericCrudService<Notification>,
        private api: CwtApiService
    ) { }

    public countFromCheck(check: NotificationCheck): Observable<number> {
        return this.notificationCrud.getAllPaginated({
            creationDate: check ? { gte: check.lastUpdateDate } : undefined,
        }, {
            options: {
                limit: 1,
                sort: '-_id'
            }
        }).pipe(
            pluck('total')
        );
    }

    public getLastCheck(): Observable<NotificationCheck> {
        return this.api.get('notificationCheck').pipe(mapApiDataItem(NotificationCheck));
    }

    public createCheck(): Observable<NotificationCheck> {
        return this.api.post(`notificationCheck`, { lastCheck: getDate12AsInt(new Date()) }).pipe(mapApiDataItem(NotificationCheck));
    }
}